/**/
window.directions = {
    "fr": [
        { "id": "EST", "text": "EST" },
        { "id": "NORD", "text": "NORD" },
        { "id": "NORD-EST", "text": "NORD-EST" },
        { "id": "NORD-OUEST", "text": "NORD-OUEST" },
        { "id": "SUD", "text": "SUD" },
        { "id": "SUD-EST", "text": "SUD-EST" },
        { "id": "SUD-OUEST", "text": "SUD-OUEST" },
        { "id": "OUEST", "text": "OUEST" },
    ],
    "en": [
        { "id": "EAST", "text": "EAST" },
        { "id": "NORTH", "text": "NORTH" },
        { "id": "NORTHEAST", "text": "NORTHEAST" },
        { "id": "NW", "text": "NORTHWEST" },
        { "id": "NORTHWEST", "text": "SOUTH" },
        { "id": "SOUTHEAST", "text": "SOUTHEAST" },
        { "id": "SOUTHWEST", "text": "SOUTHWEST" },
        { "id": "WEST", "text": "WEST" },
    ]
};

; window.Address = function (nspace,selectheight) {
    var profile = {};
    var ns = nspace;

    var selectht = selectheight ?? "300px";



    // Get text from the selected city
    profile.getSelectedCityText = function () {
        let sel = $("." + ns + " .municipality").select2('data');
        //console.log(sel);
        if (sel == undefined) {
            return;
        }
        let text = "undefined";
        if (sel.length > 0) {
            text = sel[0].text;
        }

        return text;
    } // getSelectedCityText



    // setup address tab
    profile.setupAddress = function () {
        // if validation errors visible, scroll to top
        if ($("div.alert-danger:visible").length > 0) {
            window.setTimeout(function () { window.scrollTo(0, 0) }, 1);
        }
        profile.setupMunicipality();
        profile.setupDirection();

        $("." + ns + " .unittype").select2({
            selectOnClose: true,
            allowClear: false,
            tags: false,
            width: selectht,
            minimumResultsForSearch: 10
        });

        $("." + ns + " .streetname").select2({
            language: { noResults: function () { return lang == "fr" ? "Aucun résultat trouvé" : "No results found" } },
            ajax: {
                url: prefixlang + '/address/getstreets',
                data: function (params) {
                    return {
                        term: params.term,
                        city: $("." + ns + " .municipality").val()
                    }
                },
                dataType: 'json',
                delay: 250
            },
            width: selectht,
            tags: false,
            selectOnClose: true,
            allowClear: true,
            placeholder: lang == 'fr' ? 'Recherche' : 'Search'
        });

        //$("." + ns + " .streetname").on('select2:focus', function (evt) {
        //    $(this).select2('open');
        //});
    } // setupAddress

    profile.setupMunicipality = function () {
        $("." + ns + " .municipality").select2({
            language: { noResults: function () { return lang == "fr" ? "Aucun résultat trouvé" : "No results found" } },
            ajax: {
                url: prefixlang + '/address/getcities',
                dataType: 'json',
                delay: 250
            },
            width: selectht,
            tags: false,
            selectOnClose: true, 
            allowClear: true,
            placeholder: lang == 'fr' ? 'Recherche' : 'Search'
        });
        //$("." + ns + " .municipality").on('select2:focus', function (evt) {
        //    $(this).select2('open');
        //});
    } // setupMunicipality




    profile.setupDirection = function () {
        var el = "." + ns + " .streetdirection";
        //debugger;
        var isValueSaved = $(el).val();
        if (isValueSaved) {
            $(el).find('option').remove();
        }

        // setup direction
        $(el).select2({
            selectOnClose: true,
            allowClear: false,
            data: window.directions[lang],
            tags: false,
            width: selectht,
            minimumResultsForSearch: 10
        });

        if (isValueSaved) {
            $(el).prepend('<option value="">&nbsp;</option>');
            $(el).val(isValueSaved).trigger('change');
        }
        else {
            $(el).prepend('<option value="" selected>&nbsp;</option>');
            $(el).val("").trigger('change');
        }
    }


    // init the profile page
    profile.init = function () {
        profile.setupAddress();
    }
    return profile;
}; // end Address





